import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder } from '@angular/forms';

import { AddressModel } from '../../../components/partials/address/models/address.model';
import { BaseFormComponent } from '../../../core/abstractions/base-form.component';
import { EntityTypeEnum } from '../../../models/enums/entity-type.enum';
import { ShareInfoTypeEnum } from '../../../models/enums/share-info-type.enum';
import { FormattedAddressRequestModel } from '../../../models/formatted-address-request.model';
import { ListTraderModel } from '../../../models/list-trader.model';
import { TraderSummaryModel } from '../../../models/trader-summary.model';
import { TraderModel } from '../../../models/trader.model';
import { LocationsResource } from '../../../services/resources/locations.resource';
import { MetaResource } from '../../../services/resources/meta.resource';
import { TradersResource } from '../../../services/resources/traders.resource';

@Component({
    selector: 'sl-traders-form',
    templateUrl: './traders-form.component.html',
    styleUrls: ['./traders-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TradersFormComponent extends BaseFormComponent<TraderModel, TraderSummaryModel, ListTraderModel> implements OnInit {
    EntityTypeEnum = EntityTypeEnum;
    ShareInfoTypeEnum = ShareInfoTypeEnum;
    address = new AddressModel();
    formattedAddress: string;
    readonly metaResource = inject(MetaResource);

    protected override readonly _entityResource = inject(TradersResource);

    private readonly formBuilder = inject(UntypedFormBuilder);
    private readonly locationsResource = inject(LocationsResource);

    override ngOnInit(): void {
        super.ngOnInit();
        this.setupForm();
    }

    updateFormattedAddress(): void {
        if (!!this.address.locationId) {
            this.locationsResource
                .getFormattedAddress(+this.address.locationId, this.getFormattedAddressRequest(this.address.locationId))
                .subscribe(r => (this.formattedAddress = r.value));
        }
    }

    private getFormattedAddressRequest(locationId: string): FormattedAddressRequestModel {
        return new FormattedAddressRequestModel({
            locationId: +locationId,
            companyDepartment: this.formGroup.value.companyDepartment,
            companyName: this.formGroup.value.companyName,
            firstName: this.formGroup.value.firstName,
            hasHyphen: this.formGroup.value.hasHyphen,
            isConfidential: this.formGroup.value.isConfidential,
            isPoBox: this.address.isPoBox,
            jobTitle: this.formGroup.value.jobTitle,
            languageId: this.formGroup.value.languageId,
            lastName: this.formGroup.value.lastName,
            lastNameSupplement: this.formGroup.value.lastNameSupplement,
            number: this.address.streetNumber,
            poBox: this.address.poBox,
            street: this.address.street,
            streetAfterSupplement: this.address.streetAfterSupplement,
            streetSupplement: this.address.streetSupplement
        });
    }

    private setupForm(): void {
        const controlValue = undefined;
        this.formGroup = this.formBuilder.group({
            languageId: new FormControl(controlValue, undefined),
            bpId: new FormControl(controlValue, undefined),
            displayName: new FormControl(controlValue, undefined),
            name: new FormControl(controlValue, undefined),
            nameSupplement: new FormControl(controlValue, undefined),
            department: new FormControl(controlValue, undefined),
            street: new FormControl(controlValue, undefined),
            streetSupplement: new FormControl(controlValue, undefined),
            streetNumber: new FormControl(controlValue, undefined),
            isPoBox: new FormControl(controlValue, undefined),
            poBox: new FormControl(controlValue, undefined),
            locationId: new FormControl(controlValue, undefined),
            paymentIBAN: new FormControl(controlValue, undefined),
            hasAregData: new FormControl(controlValue, undefined),
            streetAfterSupplement: new FormControl(controlValue, undefined),
            paymentTypeId: new FormControl(controlValue, undefined),
            dividendRight: new FormControl(controlValue, undefined),
            paymentTypeDescription: new FormControl(controlValue, undefined),
            locationZipCode: new FormControl(controlValue, undefined),
            locationCity: new FormControl(controlValue, undefined),
            locationCountryName: new FormControl(controlValue, undefined),
            dispoShares: new FormControl(controlValue, undefined),
            registeredShares: new FormControl(controlValue, undefined),
            countryId: new FormControl(controlValue, undefined)
        });
    }
}
